import { setupChatbotEvent } from "@src/analytics/chatbot";
import { generateRecordId } from "@src/analytics/helpers";
import { IContext } from "@src/context";
import { getInitialAccessUrl } from "@src/utils/initialAccessUrl";
import { safeRedirect } from "@src/utils/safeRedirect";
import "./index.css";

let chatbotSetup = false;

export const CHATBOT_ROOT_CLASS = "chatbot-event";

export function getChatbotRoot(): HTMLElement | null {
  return document.querySelector<HTMLElement>(
    `.chatbot-widget-root.${CHATBOT_ROOT_CLASS}`
  );
}

export function toggleChatbotButtons(visible: boolean) {
  const elements = document.querySelectorAll<HTMLElement>(
    `.${CHATBOT_ROOT_CLASS}`
  );
  elements.forEach((el) => {
    el.style.display = visible ? "flex" : "none";
  });
}

export function clearChatbot() {
  toggleChatbotButtons(false);
}

export function setupChatbot(context: IContext) {
  toggleChatbotButtons(true);

  if (chatbotSetup) return;
  chatbotSetup = true;

  const chatbotRoot = getChatbotRoot();
  if (chatbotRoot == null) {
    return;
  }

  let renderTarget: HTMLElement = chatbotRoot;
  // use another root container
  const widgetContainer = document.createElement("div");
  widgetContainer.className = "chatbot-widget-container";
  widgetContainer.style.opacity = "0";
  document.body.appendChild(widgetContainer);
  renderTarget = widgetContainer;

  setupChatbotNavigation();
  setupChatbotEvent();

  Promise.all([
    import("react-dom/client"),
    import("chatbot-widget"),
    import("chatbot-widget/styles"),
  ]).then(([{ createRoot }, { ChatbotWidget }]) => {
    const root = createRoot(renderTarget);

    const clientId = "vh-web-chatbot";
    const apiURL = import.meta.env.VITE_CHATBOT_API_URL;

    root.render(
      <ChatbotWidget
        clientId={clientId}
        apiURL={apiURL}
        url={window.location.href}
        initialAccessUrl={getInitialAccessUrl() || window.location.href}
        recordId={generateRecordId()}
        UID={generateRecordId()}
        locale={context.locale}
      />
    );
  });
}

function setupChatbotNavigation() {
  const handleNavigate = (e: CustomEvent<string>) => {
    // Set flag to skip beforeunload prevention for this navigation
    // This prevents the "leave site?" popup from appearing
    window.sessionStorage.setItem("vh-navigation-in-progress", "true");

    try {
      const url = new URL(e.detail);
      // Include pathname, search params, and hash (anchor) to preserve full URL
      safeRedirect(url.pathname + url.search + url.hash);
    } catch {
      safeRedirect(e.detail);
    }
  };
  window.addEventListener(
    "vh-navigate-same-tab",
    handleNavigate as EventListener
  );
}
